export default __webpack_public_path__ + "static/media/testimonial-user-5.90171cf4.svg";